<div class="row">
  <div class="col-xxxl-3 col-md-6" *ngFor="let statusCard of statusCards">
    <ngx-status-card (changeStatus)="addItem($event)" [title]="statusCard.title" [type]="statusCard.type">
      <i [ngClass]="statusCard.iconClass"></i>
    </ngx-status-card>
  </div>
</div>

<div class="row">
  <div class="col-xxxl-12 col-xxl-8 col-lg-7 col-md-6">
    <nb-card>
      <nb-card-header>Time Interval</nb-card-header>
      <nb-card-body>
        <nb-select matRipple selected="1" [(ngModel)]="interval">
          <nb-option matRipple value="1">1 Hour</nb-option>
          <nb-option matRipple value="6">6 Hours</nb-option>
          <nb-option matRipple value="12">12 Hours</nb-option>
          <nb-option matRipple value="24">24 Hours</nb-option>
        </nb-select>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-xxxl-12 col-xxl-8 col-lg-7 col-md-6">
    <ngx-temperatures [sensors]="activeSensors" [interval] ="interval"></ngx-temperatures>
  </div>
</div>

<div class="row">
  <div class="col-xxxl-9 col-xl-12">
    <ngx-rooms></ngx-rooms>
  </div>

  <div class="col-xxxl-3 col-xxl-4 col-lg-7 col-md-6">
    <ngx-contacts></ngx-contacts>
  </div>

  <div class="col-xxxl-3 col-xxl-4 col-lg-5 col-md-6">
    <ngx-solar [chartValue]="solarValue"></ngx-solar>

    <ngx-kitten></ngx-kitten>
  </div>

  <div class="col-xxxl-3 col-xxl-4 col-md-5">
    <ngx-traffic></ngx-traffic>
    <ngx-weather></ngx-weather>
  </div>
</div>